import React from "react";
import { HeadingWithList } from "../privacyPolicy/HeadingWithLIst";

const LISTELEMENTS: JSX.Element[] = [
  <p className="text-gray-500 pb-2" key="pp-list-1">
    <span className="font-semibold text-black">{""}</span>
    {` We are a mere host that is a market place bringing all the properties under auction by various lending institutes / regulatory authorities, and these auctions will be held ‘AS IS WHERE IS’ and ‘AS IS WHAT IS BASIS’, as stated in the disclaimer policy. `}
  </p>,
  <div className="text-gray-500 pb-2" key="pp-list-2">
    <span className="font-semibold text-black">{""}</span>
    {`The e-auction of properties will be conducted by the respective institute/authority as mentioned in the auction notices, can be referred in specific notice with or without our involvement as auction facilitating agency.`}
  </div>,
  <p className="text-gray-500 pb-2 " key="pp-list-3">
    <span className="font-semibold text-black">{""}</span>
    {`The interested buyers are bound by the principle of caveat emptor (the principle that the buyer alone is responsible for checking the quality and suitability of goods before a purchase is made).`}
  </p>,
  <p className="text-gray-500 pb-2 " key="pp-list-4">
    <span className="font-semibold text-black">{""}</span>
    {` The property is being auctioned with the details to the extent best of knowledge and information of the Authorised Officers, there are no encumbrances on the properties except those mentioned in the Notice.`}
  </p>,
  <p className="text-gray-500 pb-2 " key="pp-list-5">
    <span className="font-semibold text-black">{""}</span>
    {` We waive all liability towards the verification of property and the users. We are merely a platform that hosts these auctions. The interested buyers also can make their own independent inquiries regarding the encumbrances, title of property, specification, claims/rights/dues etc. effecting the property. Or they can opt for any Independent legal and technical experts’ assistance.`}
  </p>,

  <p className="text-gray-500 pb-2 " key="pp-list-6">
    <span className="font-semibold text-black">{""}</span>
    {` Further the bidder/purchaser should make their own inquiries regarding property offered for sale or for any dues like outstanding water/service charges, transfer fees, electricity dues, dues to the Municipal. As seller does not undertake any responsibility to procure any permission/license, NOC, etc. All users must take precaution and conduct due diligence. We will not be liable for any disputes arising out of the same. `}
  </p>,
  <p className="text-gray-500 pb-2 " key="pp-list-7">
    <span className="font-semibold text-black">{""}</span>
    {` The Authorised Officer/ Secured Creditor/Service Provider shall not be responsible in any way for any third-party claims/ rights/ dues etc.Where the Immovable Properties are subject matter of any suit, application, proceedings or Lis Pendens (i.e., a pending legal action, or a formal notice of one) before any court, tribunal, forum or any other authority, the scheduled sale will be subject to the order of such court, tribunal, forum or any other authority.`}
  </p>,
  <p className="text-gray-500 pb-2 " key="pp-list-8">
    <span className="font-semibold text-black">{""}</span>
    {` The inspection of property put on auction will be permitted after consultation of the respective bank.`}
  </p>,
];

export const Conditions = () => {
  return (
    <HeadingWithList
      heading="You agree to abide by the following conditions:"
      headingStyles="text-gray-500"
      outerContainerStyles="w-full"
      elementWrapperStyles="ml-5"
      listType="lower-roman"
      listElements={LISTELEMENTS}
    />
  );
};
